import { DisputeRelatedIcon, PayoutsTabIcon, ReceiptInvoiceIcon, RefundTransactionIcon } from 'assets/icons';

export const TypeFilters = [
  {
    key: 'QR',
    value: 'QR Code'
  },
  {
    key: 'Invoice',
    value: 'Invoice Link'
  }
];

export const StatusFilters = [
  {
    key: 'INITIATED',
    value: 'Initiated'
  },
  {
    key: 'SUCCESS',
    value: 'Success'
  },
  {
    key: 'PENDING',
    value: 'Pending'
  },
  {
    key: 'FAILED',
    value: 'Failed'
  },
  {
    key: 'CANCELLED',
    value: 'Cancelled'
  },
  {
    key: 'TIMED_OUT',
    value: 'Timed out'
  },
  {
    key: 'BLOCKED',
    value: 'Blocked'
  },
  {
    key: 'REFUNDED',
    value: 'Refunded'
  },
  {
    key: 'REFUND_INITIATED',
    value: 'Refund initiated'
  },
  {
    key: 'REFUND_FAILED',
    value: 'Refund failed'
  },
  {
    key: 'REFUND_CANCELLED',
    value: 'Refund canceled'
  },
  {
    key: 'REFUND_RETURNED',
    value: 'Refund returned'
  },
  {
    key: 'DISPUTED',
    value: 'Disputed'
  }
];

export enum ReceiptsExportPopover {
  TAB_VIEW = 'receipts-export-popover-tab',
  WEB_VIEW = 'receipts-export-popover-web'
}

export enum ReceiptFilterIds {
  STATUS = 'status',
  DATE_RANGE = 'dateRange',
  CREATED_BY = 'createdBy',
  CUSTOMERS = 'customers',
  PAYMENT_METHOD = 'paymentMethod',
  TYPE = 'type',
  AMOUNT = 'amount',
  TIP = 'tip'
}

export const DEFAULT_RECEIPT_COLUMN_CONFIG = [
  { columnKey: 'createdAt', columnLabel: 'Date', priority: 1, isEnabled: true, showAlways: true, isFocused: false },
  {
    columnKey: 'payableAmount',
    columnLabel: 'Amount',
    priority: 2,
    isEnabled: true,
    showAlways: false,
    isFocused: false
  },
  {
    columnKey: 'tipAmount',
    columnLabel: 'Tip collected',
    priority: 3,
    isEnabled: true,
    showAlways: false,
    isFocused: false
  },
  {
    columnKey: 'paymentMethod',
    columnLabel: 'Payment method',
    priority: 4,
    isEnabled: true,
    showAlways: false,
    isFocused: false
  },
  { columnKey: 'status', columnLabel: 'Status', priority: 5, isEnabled: true, showAlways: false, isFocused: false },
  {
    columnKey: 'customerName',
    columnLabel: 'Customer',
    priority: 6,
    isEnabled: true,
    showAlways: false,
    isFocused: false
  },
  {
    columnKey: 'receiptNumber',
    columnLabel: 'Receipt No.',
    priority: 7,
    isEnabled: true,
    showAlways: true,
    isFocused: false
  },
  { columnKey: 'payoutId', columnLabel: 'Payout', priority: 8, isEnabled: true, showAlways: false, isFocused: false },
  {
    columnKey: 'merchantName',
    columnLabel: 'Created by',
    priority: 9,
    isEnabled: true,
    showAlways: false,
    isFocused: false
  }
];

export enum RelatedItemsType {
  INVOICE = 'INVOICE',
  DISPUTE = 'DISPUTE',
  PAYOUT = 'PAYOUT',
  REFUND = 'REFUND',
  RECEIPT = 'RECEIPT',
  RETURN = 'RETURN'
}

export const RelatedTypes = {
  INVOICE: {
    icon: ReceiptInvoiceIcon,
    text: 'Invoice'
  },
  REFUND: {
    icon: RefundTransactionIcon,
    text: 'Refund'
  },
  RECEIPT: {
    icon: RefundTransactionIcon,
    text: 'Receipt'
  },
  DISPUTE: {
    icon: DisputeRelatedIcon,
    text: 'Dispute'
  },
  PAYOUT: {
    icon: PayoutsTabIcon,
    text: 'Payout',
    iconClass: 'path-stroke-current text-accentText h-5 w-5'
  },
  RETURN: {
    icon: ReceiptInvoiceIcon,
    text: 'Return'
  }
};

export const CARD_NETWORK = {
  AMEX: 'amex',
  VISA: 'visa',
  DISCOVER: 'discover',
  MASTERCARD: 'mastercard',
  OTHER: 'other'
};
